import Vue from 'vue'
import toast from './toast.vue'
const ToastConstructor = Vue.extend(toast)
let nId = 1
const Toast = (message) => {
  let id = 'notice-' + nId++

  const ToastInstance = new ToastConstructor({
      propsData: message,
      data: {
        show: true
      }
  })
  ToastInstance.id = id
  ToastInstance.vm = ToastInstance.$mount() // 挂载但是并未插入dom，是一个完整的Vue实例
  ToastInstance.vm.visible = true
  ToastInstance.dom = ToastInstance.vm.$el
  document.body.appendChild(ToastInstance.dom) // 将dom插入body
  ToastInstance.dom.style.zIndex = nId + 1001 // 后插入的Notice组件z-index加一，保证能盖在之前的上面
  return ToastInstance.vm
}
export default {
  install: Vue => {
    Vue.prototype.$toast = Toast // 将Notice组件暴露出去，并挂载在Vue的prototype上
  }
}


// WEBPACK FOOTER //
// ./common/commonModule/passport/components/toast.js